import React, { Component, Fragment } from 'react'
import { MenuItem, Typography, withStyles } from '@material-ui/core'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar';
import PropTypes from 'prop-types'


const styles = {
    avatar: {
      width: '34px',
      height: '34px',
      color: 'black',
      background: 'white'
    },
    userInfo: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        paddingTop: '16px',
        paddingBottom: '16px',
    },
    secundaryText : {
        fontSize: '11px',
        marginTop: '4px',
        textTransform: 'capitalize'
    },
    primaryText : {
        fontWeight: '500'
    }
}
class LeftMenuUserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            companyId: '',
            role: '',
           
          }
    }

   componentWillReceiveProps(){
       this.setState({
        name: this.props.userData.name,
        role: this.props.userData.role,
       })
   }

    render() {
        console.log('STATE', this.state)
        console.log('PROPS', this.props)
        let {classes} = this.props
        let linkColor = this.props.linkColor
        let {role, name, avatar } = this.state
        
        if(role === 'companyAdmin'){
            role = 'Administrator'
        } else {
            role = this.state.role
        }
        let letter  = ((role || "").charAt(0) || "").toUpperCase()
        console.log(role,letter)
        return (
           <Fragment>
                <MenuItem className={classes.userInfo}>
                <ListItemIcon style={linkColor}>
                { avatar  ? 
                    <Avatar className={classes.avatar} alt={name} src={avatar}  />
                :
                    <Avatar className={classes.avatar}>{letter} </Avatar>

                }
                 
                </ListItemIcon>
                    <ListItemText
                     primary={ <Typography className={classes.primaryText} style={ linkColor }>{this.state.name}</Typography>} 
                     secondary={ <Typography className={classes.secundaryText} style={ linkColor }>{role}</Typography>} />
                   
                </MenuItem>
          </Fragment>
        )
    }
}

LeftMenuUserInfo.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(LeftMenuUserInfo)